import { Lock } from "lucide-react";
import { AUTODELETING_URL } from "@/components/EncryptedBadge";

export const Footer = () => (
  <footer className="relative z-10 mt-16 border-t border-border" data-testid="site-footer">
    <div className="mx-auto flex max-w-[1440px] flex-col gap-3 px-4 py-6 text-xs text-muted-foreground sm:px-8 md:flex-row md:items-center md:justify-between">
      <p data-testid="footer-copyright">
        Copyright © GWD - Grafica Web Design ~ 2026 Powered by Pixaweb sagl -{" "}
        <a href="mailto:info@graficawebdesign.com" className="hover:text-[color:var(--au-green)]" data-testid="footer-email-link">info@graficawebdesign.com</a> -{" "}
        <a href="https://www.graficawebdesign.com" target="_blank" rel="noopener noreferrer" className="hover:text-[color:var(--au-green)]" data-testid="footer-website-link">www.graficawebdesign.com</a>
      </p>
      <a href={AUTODELETING_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest hover:text-[color:var(--au-green)]" data-testid="footer-autodeleting-link">
        <Lock size={11} /> Encrypted chat · AUTODELETING
      </a>
    </div>
  </footer>
);
